module.exports = __webpack_public_path__ + "static/media/paragon_1.f5d74014.jpg";